import { Environments } from '@/config';
import { HELIX_LCMC_PRODUCTION } from './helix-lcmc.production';
import { HELIX_LCMC_STAGING } from './helix-lcmc.staging';

export const HELIX_LCMC =
  import.meta.env.MODE === Environments.PROD ? HELIX_LCMC_PRODUCTION : HELIX_LCMC_STAGING;
